import Component from '../../../shared/component';

export default class MentorList extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$moreButton = this.$element.parent().find('.mentorList-moreTrigger');

    this.isFetchingPreviousMentors = false;
    this.shouldFetchPreviousMentors = true;

    this.bindMentors();
  }

  bindMentors() {
    this.handleMoreClick = this.handleMoreClick.bind(this);

    this.$moreButton.on('click', this.handleMoreClick);
  }

  unbindMentors() {
    this.$moreButton.off('click', this.handleMoreClick);
  }

  fetchPreviousMentors() {
    this.isFetchingPreviousMentors = true;

    const mentorIds = this.$element
      .find('.userResult')
      .toArray()
      .map((mentor) => {
        return $(mentor).data('mentor-id');
      });

    if (mentorIds.length) {
      $.get(this.$element.attr('action'), {
        // eslint-disable-next-line camelcase
        exclude_ids: mentorIds,
      }).done((data, code) => this.handlePreviousMentorsSuccess(data, code));
    } else {
      this.isFetchingPreviousMentors = false;
    }
  }

  appendPreviousMentors(html) {
    // Wrap new mentors elements in a uniquely named div
    this.$element.append(html);
  }

  hideMoreButton() {
    if (this.$moreButton) {
      this.$moreButton.hide();
    }
  }

  // Mentor handlers

  handleMoreClick() {
    if (this.shouldFetchPreviousMentors && !this.isFetchingPreviousMentors) {
      this.fetchPreviousMentors();
    }
  }

  handlePreviousMentorsSuccess(data, code) {
    if (code === 'nocontent') {
      this.hideMoreButton();
    } else {
      if (String(data).trim() !== '') {
        this.appendPreviousMentors(data);
      } else {
        // We’ve reached the bottom of the list, stop trying to fetch mentors
        this.shouldFetchPreviousMentors = false;
      }

      this.isFetchingPreviousMentors = false;
    }
  }
}
